
export function simplifyNode(node) {
  const result = {};

  if (node.type) result.type = node.type;
  if (node.nodeType) result.nodeType = node.nodeType;
  if (typeof node.level === 'number') result.level = node.level;
  if (typeof node.content === 'string' && node.content.trim()) {
    result.content = node.content.trim();
  }

  if (Array.isArray(node.children)) {
    const simplifiedChildren = node.children
      .map(simplifyNode)
      .filter(Boolean);
    if (simplifiedChildren.length > 0) {
      result.children = simplifiedChildren;
    }
  }

  return result;
}
/**
 * 
 * @param {*} input 
 * @returns 
 * [
      {
        "content": "编程语言: 精通Python, Java, C++",
        "level": 0,
        "children": [
          {
            "content": "Python：具备良好的数据分析能力，熟悉NumPy、Pandas等库",
            "level": 1
          },
          {
            "content": "Java：拥有丰富的企业级开发经验",
            "level": 1
          },
          {
            "content": "C++：擅长高性能计算",
            "level": 1
          }
        ]
      },
      ...
    ]
 */
export function parseIndentedTextToTree(input) {
  const lines = input.split('\n').map(line => line.replace(/\r$/, ''));
  const result = [];

  let currentL1 = null;

  for (let rawLine of lines) {
    const line = rawLine.trim();
    if (!line) continue;

    const leadingSpaces = rawLine.match(/^ */)[0].length;

    if (leadingSpaces === 2) {
      // 一级内容
      currentL1 = {
        content: line,
        level: 0,
        children: []
      };
      result.push(currentL1);
    } else if (leadingSpaces >= 6) {
      // 二级内容
      if (currentL1) {
        currentL1.children.push({
          content: line,
          level: 1
        });
      }
    }
  }

  return result;
}

export function parseOnePageIndentedTextToTree(input) {
  const lines = input.split('\n').map(line => line.replace(/\r$/, ''));
  const result = [];

  let currentL1 = null;
  let baseIndent = null;

  for (const rawLine of lines) {
    if (!rawLine.trim()) continue;

    const indentMatch = rawLine.match(/^(\s*)/);
    const currentIndent = indentMatch ? indentMatch[1].length : 0;
    const content = rawLine.trim();

    // 第一行非空，记录初始缩进
    if (baseIndent === null) {
      baseIndent = currentIndent;
    }

    // 计算相对缩进等级
    const relativeIndent = currentIndent - baseIndent;

    if (relativeIndent <= 0) {
      // 一级内容
      currentL1 = {
        content,
        level: 0,
        children: []
      };
      result.push(currentL1);
    } else {
      // 二级内容
      if (currentL1) {
        currentL1.children.push({
          content,
          level: 1
        });
      }
    }
  }

  return result;
}


/**
 * case	含义
 * 1	只有 1 个 level=0，且没有子级
 * 2	只有 1 个 level=0，且有子级
 * 3	多个 level=0，且都没有子级
 * 4	多个 level=0，且只有一个有子级
 * 5	多个 level=0，且有多个有子级
 * @param {*} data 
 * @returns 
 * {
    "case": 5,
    "summary": {
      "level0Total": 3,
      "level0ChildrenCounts": {
        "level0_index_0": 3,
        "level0_index_1": 1,
        "level0_index_2": 2
        }
      }
    }
  }
 */
export function analyzeTreeStructure(data) {
  const level0Count = data.length;
  let level1Summary = {}; // 记录每个 level 0 节点下的 level 1 子节点数量
  let level0WithChildrenCount = 0;

  data.forEach((item, index) => {
    const childCount = Array.isArray(item.children) ? item.children.length : 0;
    level1Summary[`level0_index_${index}`] = childCount;
    if (childCount > 0) {
      level0WithChildrenCount++;
    }
  });

  // 判断属于哪种情况
  let type = null;

  if (level0Count === 1) {
    if (level0WithChildrenCount === 0) {
      type = 1;
    } else {
      type = 2;
    }
  } else {
    if (level0WithChildrenCount === 0) {
      type = 3;
    } else if (level0WithChildrenCount === 1) {
      type = 4;
    } else {
      type = 5;
    }
  }

  return {
    caseType: type,
    summary: {
      level0Total: level0Count,
      level0ChildrenCounts: level1Summary
    }
  };
}

export function checkStringIncludeandCompareIntValue(A, B, index) {
  if (typeof A !== 'string' || typeof B !== 'string' || typeof index !== 'number') {
    return false;
  }

  const pos = A.indexOf(B);
  if (pos === -1) return false;

  const newA = A.slice(0, pos) + A.slice(pos + B.length);

  return parseInt(newA) == index;
}
